import React, { useCallback } from "react";
// import CountUp from "react-countup";

import { CountUpVariant } from "../misc";
import styles from "./StdCountUp.module.scss";
import { formatNumber } from "../../utils";

import { CountUp } from "./CountUp";

export type FormattingFn = (value: number) => string;

const formatPattern = "0,0[.][00]";

interface StdCountUpProps {
    value: number;
    decimals?: number;
    className?: string;
    variant?: CountUpVariant;
    style?: React.CSSProperties;
    formattingFn?: FormattingFn;
}
export const StdCountUp: React.FC<StdCountUpProps> = ({
    value,
    className,
    decimals = 0,
    variant = "std",
    style,
    formattingFn
}) => {
    const _formattingFn: (value: number) => string = useCallback(
        value => {
            if (formattingFn) return formattingFn(value);

            return formatNumber(value, formatPattern);
        },
        [formattingFn]
    );

    return (
        <CountUp
            start={0}
            style={style}
            end={value}
            duration={2}
            decimals={decimals}
            className={`${styles?.[variant] ?? ""} ${className ?? ""}`}
            formattingFn={_formattingFn}
        />
    );
};
